import PropTypes from 'prop-types';

export const authorProps = {
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  followedByCurrentUser: PropTypes.bool,
  summaryAudiobooks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      coverUrl: PropTypes.string.isRequired,
    }),
  ),
};

export const author = PropTypes.shape(authorProps);
